import { render, staticRenderFns } from "./CreateCompany.vue?vue&type=template&id=51269629&scoped=true"
import script from "./CreateCompany.vue?vue&type=script&lang=ts"
export * from "./CreateCompany.vue?vue&type=script&lang=ts"
import style0 from "./CreateCompany.vue?vue&type=style&index=0&id=51269629&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51269629",
  null
  
)

export default component.exports